import { checkSubscriptionStatus } from './checkSubscriptionStatus';

import type { RetryCheckSubscriptionStatusOptions } from './types';

export const retryCheckSubscriptionStatus = async (
  options: RetryCheckSubscriptionStatusOptions | void
) => {
  const {
    pollingInterval = 2000,
    maxRetries = 4,
    throwOnError = true,
    expectedStatusCode = 1,
    useExponentialBackoff = true,
    userId,
  } = options ?? {};

  let attempt = 0;

  while (attempt < maxRetries) {
    const status = await checkSubscriptionStatus(userId);

    if (status.code && status.code === expectedStatusCode) {
      return status.code;
    }

    if (status.code && attempt + 1 === maxRetries) {
      // On the last attempt, return the status code anyway
      return status.code;
    }

    attempt += 1;

    if (attempt < maxRetries) {
      // Calculate delay based on whether exponential backoff is enabled
      const delay = useExponentialBackoff
        ? pollingInterval * 2 ** (attempt - 1)
        : pollingInterval;

      await new Promise((resolve) => {
        setTimeout(resolve, delay);
      });
    }
  }

  if (throwOnError) {
    throw new Error('Failed to check subscription status');
  }

  return null;
};
